import React from "react";
import "../CSS/Services.css";


const Services2demo=()=>{
    return(
        <section className="ftco-section ftco-servicesection services2demo">
         
        <div className="container servianicon">
          <div className="row servicecardhm">
            <div className="ftco-animate servicecards">
            {/* <div className="media-body1"></div> */}
              <div className="media d-block text-center block-6 services">
                <div className="icon d-flex mb-3">
                  <span className="flaticon-facial-treatment" />
                </div>
                
                <div className="media-body">
                  
                    <h3 className="heading blackthemegradient ">Skin &amp; Beauty Care</h3>
                    <p style={{textAlign:"justify", color:"white"}}>
                    Enhance your natural glow with our expert Skin & Beauty Care services, tailored to nourish and rejuvenate your skin.
                    </p>
                  </div>
                
              </div>
              
            </div>
            <div className="ftco-animate servicecards">
              <div className="media d-block text-center block-6 services">
                <div className="icon d-flex mb-3">
                  <span className="flaticon-cosmetics" />
                </div>
                <div className="media-body">
                  <h3 className="heading blackthemegradient ">Makeup Pro</h3>
                  <p style={{textAlign:"justify",color:"white"}}>
                  Unleash your best look with our Makeup Pro services, perfect for every occasion with flawless, professional results.
                  </p>
                </div>
              </div>
            </div>
            <div className="ftco-animate servicecards" >
              <div className="media d-block text-center block-6 services">
                <div className="icon d-flex mb-3">
                  <span className="flaticon-curl" />
                </div>
                <div className="media-body">
                  <h3 className="heading blackthemegradient ">Hair Style</h3>
                  <p style={{textAlign:"justify",color:"white"}}>
                  Achieve the perfect look with our expert Hair Styling services, tailored to match your unique style and personality.
                  </p>
                </div>
              </div>
            </div>
            <div className="ftco-animate servicecards">
              <div className="media d-block text-center block-6 services">
                <div className="icon d-flex mb-3">
                <span className="flaticon-flower" />
                </div>
                <div className="media-body">
                  <h3 className="heading blackthemegradient ">Aesthetic</h3>
                  <p style={{textAlign:"justify", color:"white"}}>
                  Unwind with our premium treatments, featuring carefully curated products that nourish and rejuvenate.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
}

export default Services2demo;